export const JobsLsKeys = {
  HASURA_EP: 'hasura_http_ep',
  HASURA_WS_EP: 'hasura_wss_ep',
  SUBDOMAIN: 'subdomain',
};
